export default "__VITE_ASSET__PIzFxT9L__"